import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getPortraitImageData } from '../HeadlinesSection/helpers'
import { isAllImageAssetsReady } from '../../helpers'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { getInitialValues } from './fields'
import { PORTRAIT_IMAGE, portraitImageHeight, portraitImageWidth } from '../../../../fields'
import { portraitImageValidationSchema } from '../../../../validations'

const PortraitImageSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalPortraitImageAssets = useMemo(() => getPortraitImageData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalPortraitImageAssets), [originalPortraitImageAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalPortraitImageAssets,
    fieldType: googleAssetFieldType.PORTRAIT_MARKETING_IMAGE,
    sectionValueKey: PORTRAIT_IMAGE,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    title,
    adAccount
  })

  const { values } = purifiedFormik

  const isImagesReady = isAllImageAssetsReady(values, PORTRAIT_IMAGE)

  const isEmptyList = !values[PORTRAIT_IMAGE].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      submitBtnDisabled={!isImagesReady}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={PORTRAIT_IMAGE}
        validationSchema={portraitImageValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add portrait image' : 'Add another portrait image'}
        width={portraitImageWidth}
        height={portraitImageHeight}
      />
    </EditForm>
  )
}

export default PortraitImageSectionForm
